interface RandomWordsArgs {
	minWords: number;
	maxWords: number;
	minWordLength: number;
	maxWordLength: number;
}

export function generateRandomWords(args: RandomWordsArgs): string {
	const random = (min: number, max: number) => Math.floor(Math.random() * (max + 1 - min)) + min;
	const { minWords, maxWords, minWordLength, maxWordLength } = args;

	return Array.from({ length: random(minWords, maxWords) }, () =>
		'-'.repeat(random(minWordLength, maxWordLength))).join(' ');
}
